import type { ExperienceDetails } from '@atlassian/jira-business-experience-tracking/src/types.tsx';
import { DATE_VALUE_OPERATORS } from '@atlassian/jira-business-fields/src/common/field-types/date/evaluate-format-rule/constants.tsx';

export const MAX_RULES_FETCHED = 20;
export const DATE_VALUES = DATE_VALUE_OPERATORS;

export const DATE_PICKER_OPERATORS = [DATE_VALUE_OPERATORS.EXACT_DATE];

export const PACKAGE_NAME = 'jiraBusinessFormatRule';
export const TEAM_NAME = 'keystone';

export const CREATE_FORMAT_RULE_EXPERIENCE: ExperienceDetails = {
	experience: 'createFormatRule',
	packageName: PACKAGE_NAME,
	teamName: TEAM_NAME,
};

export const LIST_FORMAT_RULE_EXPERIENCE: ExperienceDetails = {
	experience: 'listFormatRule',
	packageName: PACKAGE_NAME,
	teamName: TEAM_NAME,
};

export const DELETE_FORMAT_RULE_EXPERIENCE: ExperienceDetails = {
	experience: 'deleteFormatRule',
	packageName: PACKAGE_NAME,
	teamName: TEAM_NAME,
};

export const UPDATE_FORMAT_RULE_EXPERIENCE: ExperienceDetails = {
	experience: 'updateFormatRule',
	packageName: PACKAGE_NAME,
	teamName: TEAM_NAME,
};

export const SORT_FORMAT_RULE_EXPERIENCE: ExperienceDetails = {
	experience: 'sortFormatRule',
	packageName: PACKAGE_NAME,
	teamName: TEAM_NAME,
};

export const HELP_ARTICLE = {
	helpArticleId: '7afzXgtL4UauMCJZ3IxTTH',
	href: 'https://support.atlassian.com/jira-software-cloud/docs/what-are-format-rules/',
};
